import React, { useState } from "react";
import { AppBar, Box, Button, Divider, Drawer } from "@mui/material";
import { Grid, IconButton, List } from "@mui/material";
import { Stack, Toolbar, Typography, styled } from "@mui/material";
import { ImgBox } from "./style";
import StoreIcon from "../../images/managekaro icon.png";
import Location from "../../images/distance.png";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { ButtonAdd } from "../../components/styles";
import BackIcon from "../../images/undo.svg";

const drawerWidth = 240;

const Title = styled(Typography)({
  fontFamily: "Roboto",
  fontSize: "17px",
  fontWeight: 600,
  color: "#4CAF50",
});

function StoreHeader({ image, title, userName, address = "" }) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ flex: 1, overflow: "auto", p: "8px" }}>
        <Stack
          width="100%"
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Link onClick={toggle} to="/inventory/admin">
            <img
              height="80px"
              width="80px"
              src={image || StoreIcon}
              alt="logo"
            />
          </Link>
          <Title sx={{ fontSize: "14px" }}>{title || ""}</Title>
        </Stack>
        <Stack alignItems="center" justifyContent="center">
          {/* <Title sx={{ color: "#808080" }}>Retail Shop</Title> */}
          <Stack
            spacing="8px"
            direction="row"
            justifyContent="center"
            width="100%"
          >
            <img src={Location} alt="" />
            <Title sx={{ color: "#4CAF50" }}>{address}</Title>
          </Stack>
        </Stack>
        <Divider sx={{ my: "16px" }} />
        <List>
          <Box sx={{ display: "flex", justifyContent: "center", mb: "8px" }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                background: "#ACE1FF !important",
                color: "#323232",
                textTransform: "none",
                boxShadow: "none !important",
              }}
            >
              <CallIcon sx={{ mr: "8px" }} /> Call Store
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mb: "8px" }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                background: "#B8FFAC !important",
                color: "#323232",
                textTransform: "none",
                boxShadow: "none !important",
              }}
            >
              <WhatsAppIcon sx={{ mr: "8px", color: "#4CAF50" }} /> Send
              WhatsApp
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {location.pathname == `/store/${userName}/cart` && (
              <Link to={`/store/${userName}`}>
                <ButtonAdd
                  variant="contained"
                  sx={{ textTransform: "none", ml: 0 }}
                >
                  <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                </ButtonAdd>
              </Link>
            )}
            {location.pathname == `/inventory/admin/store/${userName}/cart` && (
              <Link to={`/inventory/admin/store/${userName}`}>
                <ButtonAdd
                  variant="contained"
                  sx={{ textTransform: "none", ml: 0 }}
                >
                  <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                </ButtonAdd>
              </Link>
            )}
          </Box>
        </List>
      </Box>
      <Box sx={{ background: "white" }}></Box>
    </Box>
  );
  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          background: "#FFFFFF",
          boxShadow: "none",
          px: { xs: "1px", md: "60px" },
          display: { xs: "flex", sm: "flex", md: "none" },
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "flex", sm: "flex", md: "none" } }}
            onClick={toggle}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Title sx={{ fontSize: "14px" }}>My ManageKaro Store</Title>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { xs: "50%", sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "50%", sm: drawerWidth },
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        sx={{
          background: "#fff",
          p: "12px 32px",
          display: { xs: "none", sm: "none", md: "block" },
        }}
      >
        <Grid container spacing="16px">
          <Grid item md={10} xs={12}>
            <Stack direction="row" spacing={2} alignItems="center">
              <ImgBox
                sx={{ background: "#D7F5D8", height: "100px", width: "100px" }}
              >
                <img
                  height="80px"
                  width="80px"
                  src={image || StoreIcon}
                  alt=""
                />
              </ImgBox>
              <Stack>
                <Title>{title || ""}</Title>
                {/* <Title sx={{ color: "#808080" }}>Retial Shop</Title> */}
                <Stack spacing="8px" direction="row">
                  <Title sx={{ color: "#4CAF50" }}>{address}</Title>
                  <img src={Location} alt="" />
                </Stack>
              </Stack>
            </Stack>
          </Grid>

          <Grid
            item
            md={2}
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                fullWidth
                variant="contained"
                size="small"
                sx={{
                  background: "#ACE1FF !important",
                  color: "#323232",
                  textTransform: "none",
                  boxShadow: "none !important",
                }}
              >
                <CallIcon sx={{ mr: "8px" }} /> Call Store
              </Button>
              <Button
                fullWidth
                variant="contained"
                size="small"
                sx={{
                  background: "#B8FFAC !important",
                  color: "#323232",
                  textTransform: "none",
                  boxShadow: "none !important",
                  my: "8px",
                }}
              >
                <WhatsAppIcon sx={{ mr: "8px", color: "#4CAF50" }} /> Send
                WhatsApp
              </Button>
              {location.pathname == `/store/${userName}/cart` && (
                <Link to={`/store/${userName}`}>
                  <ButtonAdd
                    fullWidth
                    variant="contained"
                    sx={{ textTransform: "none", ml: 0, px: 6.4 }}
                  >
                    <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                  </ButtonAdd>
                </Link>
              )}
              {location.pathname ==
                `/inventory/admin/store/${userName}/cart` && (
                <Link to={`/inventory/admin/store/${userName}`}>
                  <ButtonAdd
                    fullWidth
                    variant="contained"
                    sx={{ textTransform: "none", ml: 0, px: 6.4 }}
                  >
                    <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                  </ButtonAdd>
                </Link>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default StoreHeader;
